import { useEffect, useState } from "react";
import { Routes, Route, useNavigationType, useLocation, Navigate, } from "react-router-dom";
import UserOnboarding from "./pages/OnBoarding/UserOnboarding";
import UserOnboarding1 from "./pages/OnBoarding/UserOnboarding1";
import ChangePhone from "./pages/OnBoarding/ChangePhone";
import UserOnboarding2 from "./pages/OnBoarding/UserOnboarding2";
import UserOnboarding3 from "./pages/OnBoarding/UserOnboarding3";
import Login from "./pages/Login/Login";
import Mfa from "./pages/Login/Mfa";
import "./global.css";
import "./DashboardGlobal.css"
// import Home from "./pages/DashBoard/Home";
import AllUsers from "./pages/DashBoard/AllUsers";
import CompanyProfile from "./pages/DashBoard/CompanyProfile";
import CreateDocument from "./pages/DashBoard/CreateDocument";
import Header from "./components/DashBoard/Header";
import Footer from "./components/DashBoard/Footer";
import Error from "./components/OnBoard/Error";
import { useSelector } from "react-redux";
import BulkUpload from "./pages/DashBoard/BulkUpload";
import FixErrors from "./pages/DashBoard/FixErrors";
import ExternalDash from "./pages/DashBoard/ExternalDash";
import ForgotPassword from "./components/OnBoard/ForgotPassword";
import ResetPassword from "./components/OnBoard/ResetPassword";
import VerifyPassword from "./components/OnBoard/VerifyPassword";
import { LogEvents } from "./Utils/eventLogger";
import GlobalTemplates from "./pages/DashBoard/Templates/GlobalTemplates";
import { OnboardingRoutes } from "./Routes/OnboardingRoutes";
import { ProtectedRoutes } from "./Routes/ProtectedRoutes";
import CartDetail from "./pages/Cart/CartDetails";
import GlobalAppeals from "./pages/DashBoard/GlobalAppeals";
import GlobalRequests from "./pages/DashBoard/GlobalVerifierRequests";
import Payments from "./pages/DashBoard/Payments";
import CompanyInsight from "./pages/DashBoard/CompanyInsight";
import { UnifiedOnboardingRoutes } from "./Routes/UnifiedOnboadingRoutes";
import DashboardMetrics from "./pages/DashBoard/DashboardMetrics";
import TermAndPoliy from "./pages/TermAndPolicy/TermAndPolicy";
import PrivacyPolicy from "./pages/Contact Us/PrivacyPolicy";
import ContactUs from "./pages/Contact Us/ContactUs";
import TermAndCondition from "./pages/Contact Us/TermAndCondition";
import Index from "./LandingPages/Lp"
import Services from "./pages/Contact Us/Services";
import VerifyPhone from "./components/OnBoard/VerifyPhone";
import VerifyOTP from "./components/OnBoard/VerifyOTP";
import OnboardUsers from "./components/OnBoard/OnboardUsers";
import AuthNumberOfferPage from "./pages/Rewards/AuthNumberOfferPage";
import OfferPlatform from "./pages/Rewards/OfferPlatform";
import { AuthConsole } from "./Utils/helper";
import useTimeTracking from "./Hooks/useTimeTracking";
import CentralWallet from "./components/CentralWallet/CentralWallet";
import Reports from "./pages/DashBoard/Reports";
import cogoToast from "cogo-toast-react-17-fix";
import UserOnboarding4 from "./pages/OnBoarding/UserOnboarding4";
import BusinessDetailsOverseas from "./pages/OnBoarding/BusinessDetailsOverseas";
import GSTINStatus from "./pages/OnBoarding/GSTINStatus";
import CompanyDetailsOnshore from "./pages/OnBoarding/CompanyDetailsOnshore";
import Onboarding from "./pages/OnBoarding/Onboarding";
import Onboarding1 from "./pages/OnBoarding/Onboarding1";
import IssuedDataDetails from "./pages/DashBoard/IssuedDataDetails";
import Consent from "./pages/DashBoard/Consent/Consent";
import CreditHandler from "./pages/DashBoard/ExternalDash/Credit/CreditHandler";


function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  const [notifications, setNotifications]=useState([])
  useTimeTracking()
  const User = useSelector(state => state.User)


  const GA_ID=process.env.REACT_APP_GA_ID
  
  
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", GA_ID, {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, [location])
  // console.log(GA_ID);
  
  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);


  //  useEffect(()=>{
  //    const handleClick = (event) =>{
  //      const target = event.target;
  //      // console.log(event)
  //      LogEvents(User.user_name,"click", {id:target.id, text:target.innerText})
  //      // console.log(target.id, target.innerText)
  //    }
  //
  //    document.addEventListener('click', handleClick);
  //    return () => document.removeEventListener('click', handleClick);
  //  },[])

  useEffect(() => {
    let metaDescription = "";

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  AuthConsole("User:", User.user_type);
  
  useEffect(() => {
    if (!User?.id) return;
  
    const eventSource = new EventSource(
      User.user_type=="Issuer"?`${process.env.REACT_APP_BASE_URL}api/v1/notification/issuer/${User.id}`:`${process.env.REACT_APP_BASE_URL}api/v1/notification/verifier/${User.id}`
    );
  
    eventSource.addEventListener("notification", (event) => {
      const data = JSON.parse(event.data);
  
      const message = `You have ${data.total} pending actions`;
      console.log(message);
      
  
      setNotifications([data]);
    });
  
    eventSource.addEventListener("ping", () => {
      console.log("SSE alive");
    });
  
    eventSource.onerror = (err) => {
      console.log("SSE error", err);
    };
  
    return () => eventSource.close();
  }, [User?.id])
  const hostname = window.location.hostname;
  const hashValue = location.hash
  if (hashValue) {
    localStorage.setItem("doc_token", hashValue);
  }
  useEffect(() => {
    // const hostname = window.location.hostname;
    // const hashValue = location.hash;        // "#1233" from React Router
    const hashToken = location.hash.substring(1); // "1233" without #

    if (hostname !== "authnumber.verify-details.com") return;
  
    if (hashValue && !User?.id) {
      localStorage.setItem("doc_token", hashValue);
    }
  
    setTimeout(() => {
      if (User?.id) {
        window.location.replace(
          `https://authnumber-frontend.authbridge.com/dashboard/verify-details${hashValue}`
        );
      } else {
        window.location.replace(
          `https://authnumber-frontend.authbridge.com/login${hashValue}`
        );
      }
    }, 200)
  
  }, [User?.id]);
  useEffect(() => {
    // const hostname = window.location.hostname;
    // const hashValue = location.hash;        // "#1233" from React Router
    const hashToken = location.hash.substring(1); // "1233" without #

    if (hostname !== "verify.authnumber.com") return;
  
    if (hashValue && !User?.id) {
      localStorage.setItem("doc_token", hashValue);
    }
  
    setTimeout(() => {
      if (User?.id) {
        window.location.replace(
          `https://app.authnumber.com//dashboard/verify-details${hashValue}`
        );
      } else {
        window.location.replace(
          `https://app.authnumber.com/login${hashValue}`
        );
      }
    }, 200)
  
  }, [User?.id])
// if (
//   window.location.hostname === "authnumber.verify-details.com"
// ) {
//   const hashValue = window.location.hash.substring(1)
//   localStorage.setItem("doc_token",hashValue)
//   window.location.replace(
//     `https://authnumber-frontend.authbridge.com/dashboard/verify-details${hashValue}`
//   );
// }
  return (
    <>
      {location.pathname.includes('/app/') || location.pathname.includes('/home') || location.pathname.includes('Authnumber-rewards') || location.pathname.includes('offer-platform') || location.pathname.includes('/login') ? null : User?.user_name ? <Header notifications={notifications} /> : null}
      <Routes >
        <Route element={<OnboardingRoutes />}>
        <Route path="/" element={<Navigate to ="/login"/>}/>
          <Route exact strict path="/login" element={<Login />} />
          <Route exact strict path="/app/mfa" element={<Mfa />} />
          <Route exact strict path="/app/forgotPassword" element={<ForgotPassword />} />
          {/* <Route path="/app/forgot-password/:token" element={<ResetPassword />} /> */}
          <Route exact strict path="/app/verify" element={<VerifyPassword />} />
          {/* <Route exact strict path="/app/TermandPolicy" element={<TermAndPoliy/>}/> */}
          {/* <Route exact strict path="/app/TermandPolicy" element={<TermAndPoliy/>}/> */}
          {/* <Route exact strict path="/Term-and-Condition" element={<TermAndCondition/>}/> */}
        </Route>
        <Route element={<UnifiedOnboardingRoutes/>}>


        <Route path="/app/Onboarding/" element={<Onboarding />} />
        <Route path="/app/registration/:token" element={<UserOnboarding/>}/>
          <Route exact strict path="/app/registration/step1" element={<UserOnboarding1 />} />
          <Route exact strict path="/app/registration/step2" element={<UserOnboarding2 />} />
          <Route exact strict path="/app/registration/step3" element={<UserOnboarding3 />} />
          <Route exact strict path="/app/registration/step4" element={<UserOnboarding4/>}/>

          <Route exact strict path="/app/Onboarding/step1" element={<Onboarding1/>}/>
          <Route exact strict path="/app/registration/business-details-overseas" element={<BusinessDetailsOverseas/>}/>
          <Route exact strict path="/app/registration/onshore-status" element={<GSTINStatus/>}/>
          <Route exact strict path="/app/registration/companydetailsOnshore" element={<CompanyDetailsOnshore/>}/>
          <Route exact strict path="/app/registration/changephone" element={<ChangePhone />} />
          <Route path="/app/forgot-password/:token" element={<ResetPassword />} />
          <Route path ="/app/verifyPhone" element={<VerifyPhone/>}/>
          <Route path="/app/VerifyOtp" element={<VerifyOTP/>}/>

          <Route exact strict path="/Term-and-Policy" element={<TermAndPoliy/>}/>
          <Route exact strict path="/privacy-policy" element={<PrivacyPolicy/>}/>
          <Route exact strict path="/contact-us" element={<ContactUs/>}/>

          <Route exact strict path="/Term-and-Condition" element={<TermAndCondition/>}/>

          {/* <Route exact strict path="/" element={<Index/>}/> */}
          <Route exact strict path="/Services" element={<Services/>}/>
          <Route exact strict path="/app/onboardUsers" element={<OnboardUsers/>}/>
          <Route exact strict path="/verification/consent" element={<Consent/>}/>

          <Route path="/centralWallet_paymentGateway/:token" element={<CentralWallet/>}/>
          {/* <Route path="/authnumber-rewards/:user_uuid/:client_code/:package_type" element={<AuthNumberOfferPage/>}/>
          <Route path="Offer-platform" element={<OfferPlatform/>}/> */}

        </Route>
        <Route element={<ProtectedRoutes />}>
        {/* <Route path="/" element={<Navigate to="/" />} /> */}
          <Route path="/dashboard/*" strict element={(User.user_type==="Super Admin") ? <DashboardMetrics /> : <ExternalDash />} />
          <Route path="/dashboard/*" element={(User.user_type==="Super Admin") ? <DashboardMetrics /> : <ExternalDash />} />
          <Route path="/Company/:user_type/:id/*" element={<CompanyProfile />} />
          <Route path='/templates' element={<GlobalTemplates />} />
          <Route path='/forms' element={<GlobalTemplates />} />
          <Route path='/help' element={<GlobalTemplates />} />
          <Route path="/appeals" element={<GlobalAppeals/>}/>
          <Route path="/requests" element={<GlobalRequests/>}/>


          <Route path="/adjustCredit/:companyId" element={<CreditHandler/>}/>

          <Route path="/insights" element={<CompanyInsight/>}/>
          <Route path="/users" element={<AllUsers/>}/>
          <Route path="/payments" element={<Payments/>}/>
          <Route path="/Create/:id/*" element={<CreateDocument />} />

          <Route path="/reports" element={<Reports/>}/>
          <Route path="/issued_data_details/:id" element={<IssuedDataDetails/>}/>
          <Route path="/Bulkupload" element={<BulkUpload />} />
          <Route path="/BulkUpload/Fixerrors" element={<FixErrors />} />
          <Route path="*" element={<Error />} />
        </Route>
      </Routes>
      {location.pathname.includes('/app/') || location.pathname.includes('/Help') ? null : <Footer />}
    </>
  )

}
export default App;